(function () {
  if (window.__bbbMarketingSignup) return;
  window.__bbbMarketingSignup = true;

  var ENDPOINT = "https://ddtueahqskfntayyzkxm.supabase.co/functions/v1/marketing-signup";

  function fieldValue(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el && typeof el.value === "string" ? el.value : "";
  }

  function inputValue(form, selector) {
    var el = form.querySelector(selector);
    return el && typeof el.value === "string" ? el.value : "";
  }

  function showMessage(form, selector, message) {
    var el = form.querySelector(selector);
    if (!el) return;
    if (message) el.textContent = message;
    el.hidden = false;
  }

  function hideMessage(form, selector) {
    var el = form.querySelector(selector);
    if (!el) return;
    el.hidden = true;
  }

  function firstInvalid(form) {
    var fields = form.querySelectorAll("[required]");
    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      if (field.type === "checkbox" || field.type === "radio") {
        if (!field.checked) return field;
      } else if (!field.value || (field.checkValidity && !field.checkValidity())) {
        return field;
      }
    }
    return null;
  }

  function invalidMessage(field) {
    if (field && (field.type === "checkbox" || field.type === "radio")) {
      return "Please agree to receive communications.";
    }
    if (field && (field.type === "email" || field.name === "email")) {
      return "Please enter a valid email address.";
    }
    if (field && field.name === "phone") return "Please enter your phone number.";
    return "Please complete the required fields.";
  }

  function postSignup(payload, keepalive) {
    return fetch(ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
      keepalive: !!keepalive,
    }).then(function (response) {
      return response.json().then(
        function (body) {
          return { ok: response.ok, body: body };
        },
        function () {
          return { ok: false, body: null };
        }
      );
    });
  }

  // Also subscribe Bye Bye Button newsletter sign-ups as Shopify customers,
  // so they land in Shopify Messaging. Fire-and-forget: never blocks the form.
  function postShopifySubscribe(payload) {
    if (payload.list_slug !== "bye-bye-button" || payload.signup_kind !== "newsletter") return;
    if (!payload.email || payload.company) return;
    var source = payload.comment === "newsletter popup" ? "site-popup" : "site-form";
    var data = new URLSearchParams();
    data.append("form_type", "customer");
    data.append("utf8", "✓");
    data.append("contact[email]", payload.email);
    data.append("contact[tags]", "newsletter," + source);
    if (payload.name) data.append("contact[first_name]", payload.name);
    try {
      fetch("/contact#marketing-signup", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
        credentials: "same-origin",
        keepalive: true,
      }).catch(function () {});
    } catch (e) {}
  }

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || !form.getAttribute) return;

      if (form.id === "ContactForm") {
        var contactEmail = inputValue(form, "#ContactForm-email").trim();
        if (!contactEmail) return;
        postSignup(
          {
            list_slug: "bye-bye-button",
            signup_kind: "contact",
            email: contactEmail,
            name: inputValue(form, "#ContactForm-name"),
            phone: inputValue(form, "#ContactForm-phone"),
            comment: inputValue(form, "#ContactForm-body"),
            company: "",
          },
          true
        ).catch(function () {});
        return;
      }

      if (!form.hasAttribute("data-marketing-signup")) return;
      event.preventDefault();

      hideMessage(form, "[data-marketing-signup-error]");
      hideMessage(form, "[data-marketing-signup-success]");

      var emailInput = form.querySelector('[name="email"]');
      var invalid = firstInvalid(form);
      if (invalid) {
        showMessage(form, "[data-marketing-signup-error]", invalidMessage(invalid));
        var error = form.querySelector("[data-marketing-signup-error]");
        invalid.setAttribute("aria-invalid", "true");
        if (error) {
          if (!error.id) error.id = (form.id || "marketing-signup") + "-error";
          invalid.setAttribute("aria-describedby", error.id);
        }
        invalid.focus();
        return;
      }
      if (emailInput) emailInput.removeAttribute("aria-invalid");

      var button = form.querySelector('[type="submit"]');
      if (button) button.disabled = true;

      var commentInput = form.querySelector('[name="comment"]');
      var comment = "";
      if (commentInput) {
        comment = commentInput.value.trim();
        var maxComment = parseInt(commentInput.getAttribute("maxlength") || "1000", 10);
        if (comment.length > maxComment) {
          showMessage(
            form,
            "[data-marketing-signup-error]",
            "Please keep your comment to " + maxComment + " characters."
          );
          if (button) button.disabled = false;
          commentInput.focus();
          return;
        }
      } else if (window.location && window.location.pathname) {
        comment = window.location.pathname;
      }

      var payload = {
        list_slug: fieldValue(form, "list_slug"),
        signup_kind: fieldValue(form, "signup_kind"),
        email: emailInput.value,
        name: fieldValue(form, "name"),
        phone: fieldValue(form, "phone"),
        comment: comment,
        company: fieldValue(form, "company"),
      };

      postShopifySubscribe(payload);

      postSignup(payload, false)
        .then(function (result) {
          if (result.ok && result.body && result.body.ok === true) {
            var nameInput = form.querySelector('[name="name"]');
            if (nameInput) nameInput.value = "";
            if (emailInput) emailInput.value = "";
            var phoneInput = form.querySelector('[name="phone"]');
            if (phoneInput) phoneInput.value = "";
            if (commentInput && commentInput.type !== "hidden") {
              commentInput.value = "";
              commentInput.dispatchEvent(new Event("input", { bubbles: true }));
            }
            var success = form.querySelector("[data-marketing-signup-success]");
            if (success) {
              success.hidden = false;
              success.focus();
            }
            form.dispatchEvent(new CustomEvent("marketing-signup:success", { bubbles: true }));
            return;
          }
          showMessage(form, "[data-marketing-signup-error]", "Something went wrong. Please try again.");
        })
        .catch(function () {
          showMessage(form, "[data-marketing-signup-error]", "Something went wrong. Please try again.");
        })
        .then(function () {
          if (button) button.disabled = false;
        });
    },
    true
  );
})();

